const patterns = {
    email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
    phone: /^\d{7,13}$/,
    text: /[A-Za-z]/ig,
    password: '',
    float: '',
    integer: '',
    errors: {
        email: 'A valid email address is required'
    }
}

export default patterns
